import { useEffect, useState } from 'react';
import { Form } from "react-bootstrap";
import { create } from '../../services/upload-files.service';
import useFetch from '../../hooks/useFetch';
import CheckboxTree from 'react-checkbox-tree';
import fetchApi from '../../services/fetch-data.service';
import 'react-checkbox-tree/lib/react-checkbox-tree.css'; // Keep default styles

const AssignPermission = () => {
    const [formData, setFormData] = useState({});
    const [validationErrors, setValidationErrors] = useState({});
    const [roleid, setRoleId] = useState('');
    const [checked, setChecked] = useState([]); 
    const [expanded, setExpanded] = useState([]);
    const [successMessage, setSuccessMessage] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const { data } = useFetch('role');
    const { data: allpermissions } = useFetch('role/get-all-permissions');

    useEffect(() => {
        const fetchData = async (roleid) => {
            try {
                const res = await fetchApi(`role/get-role-permission-by-roleid/${roleid || ""}`);
                if (res.status === 200) {
                    const responseData = res.data.data;
                    if (Array.isArray(responseData)) {
                        setChecked(responseData);
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData(roleid);
    }, [roleid]);

    const resetForm = () => {
        setFormData({});
        setRoleId('');
        setSelectedRole('');
        setChecked([]);
        setExpanded([]);
        setValidationErrors({});
    };

    const handleInputChange = (e) => {
        if (!Array.isArray(e)) {
            const value = e.target.value;
            const name = e.target.selectedOptions[0]?.getAttribute('data-name');
            setRoleId(value);
            setSelectedRole(value);
            setFormData((prevData) => ({ ...prevData, [name]: value }));
            setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
        } else {
            setFormData((prevData) => ({ ...prevData, permission: e }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                formData.permission = checked;
                const res = await create(formData, 'role/assign-permission');
                if (res.success && res.data.affectedRows > 0) {
                    setSuccessMessage('Permissions assigned successfully!');
                    setTimeout(() => {
                        resetForm();
                        setSuccessMessage('');
                    }, 3000);
                } else {
                    setValidationErrors({ err: 'Failed to assign permissions' });
                }
            } catch (error) {
                setValidationErrors({ err: 'An error occurred. Please try again later' });
            }
        }
    };

    const validateFormFields = (formData) => {
        const errors = {};
        if (!formData.role_id || formData.role_id.trim() === '') {
            errors.role_id = 'Please Select Role';
        }
        return errors;
    };

    function areAllValuesInB(children, checked) {
        let checkedSet = new Set(checked);
        for (let value of children) {
            if (checkedSet.has(value.value)) {
                return true;
            }
        }
        return false;
    }

    return (
        <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <style>{`
                .rct-node {
                     background-image: none !important;

                }
                .rct-text {
                    padding: 4px 6px;
                    display: flex;
                    align-items: center;
                    border-radius: 4px;
                    transition: background-color 0.2s;
                }
                .rct-text:hover {
                    background-color: #eef6ff;
                }
                .rct-title {
                    font-size: 14px;
                }
                .rct-node-parent > .rct-text > label > span.rct-title {
                    font-weight: 600;
                }
                .rct-checkbox {
                    transform: scale(1.2);
                    margin-right: 8px;
                }
                .rct-collapse, .rct-node-icon {
                    margin-right: 6px;
                }
                .rct-node-parent {
                    border-left: 2px solid #e0e0e0;
                    padding-left: 8px;
                }
                .rct-node-leaf {
                    border-left: 2px dashed #ddd;
                    padding-left: 8px;
                }
            `}</style>

            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 className="h2">Assign Permission to Role</h1>
            </div>

            <div className='row'>
                <div className='col-6'>
                    <div className='editprofile'>
                        {successMessage && (
                            <div className="alert alert-success" role="alert">
                                {successMessage}
                            </div>
                        )}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="role">
                                <Form.Label>Select Role</Form.Label>
                                <Form.Select 
                                    value={selectedRole} 
                                    onChange={handleInputChange}
                                >
                                    <option value="" disabled>Select Role</option>
                                    {data.data && data.data.length > 0 ? data.data.map((role, index) => (
                                        <option data-name="role_id" value={role.id} key={index}>
                                            {role.role_name}
                                        </option>
                                    )) : ""}
                                </Form.Select>
                                {validationErrors.role_id && <div className="error login-error">{validationErrors.role_id}</div>}
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="permissions">
                                <Form.Label>Select Permissions</Form.Label>
                                
                                <div style={{
                                    border: '1px solid #ccc',
                                    borderRadius: '6px',
                                    padding: '10px',
                                    maxHeight: '300px',
                                    overflowY: 'auto',
                                    backgroundColor: '#f9f9f9'
                                }}>
                                    <CheckboxTree
                                    
                                        nodes={allpermissions && Object.keys(allpermissions).length > 0 ? allpermissions.data : []}
                                        checked={checked}
                                        expanded={expanded}
                                        onCheck={(checkedItems, parentIds) => {
                                            setChecked(checkedItems);
                                            if (parentIds.parent?.children || parentIds.children) {
                                                let childrenData = parentIds.parent?.children || parentIds.children;
                                                let result = areAllValuesInB(childrenData, checkedItems);
                                                if (result || (parentIds.isParent && parentIds.checked)) {
                                                    let pId = parentIds.parent?.value || parentIds.value;
                                                    setChecked(prevData => {
                                                        if (!prevData.includes(pId)) {
                                                            return [...prevData, pId];
                                                        } else {
                                                            return prevData;
                                                        }
                                                    });
                                                } else {
                                                    let pId = parentIds.isParent ? parentIds.value : parentIds.parent?.value;
                                                    setChecked(prevIds => prevIds.filter(id => id !== pId))
                                                }
                                            }
                                            handleInputChange(checkedItems);
                                        }}
                                        onExpand={expandedItems => setExpanded(expandedItems)}
                                    />
                                </div>
                            </Form.Group>

                            <button className="btn btn-primary btn-add mb-3" type='submit'>Save</button>
                        </Form>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default AssignPermission;
